<template>
  <a-card :bordered="false" class="table-card">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="请选择星期几">
              <j-dict-select-tag
                v-model="queryParam.dayOfWeek"
                placeholder="请选择星期几"
                dictCode="dayOfWeek"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <schoolCounselingConfig-modal ref="modalForm" @ok="modalFormOk"></schoolCounselingConfig-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import SchoolCounselingConfigModal from './components/SchoolCounselingConfigModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'TutorTimeSetting',
  mixins: [JeecgListMixin],
  components: {
    SchoolCounselingConfigModal,
  },
  data() {
    return {
      description: '心理辅导时间段配置管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '每周星期几',
          align: 'center',
          dataIndex: 'dayOfWeek_dictText',
        },
        {
          title: '可预约辅导时间段',
          align: 'center',
          customRender: function (t, r, index) {
            return r.beginTime + ' ~ ' + r.endTime
          },
        },
        {
          title: '可预约辅导次数',
          align: 'center',
          dataIndex: 'num',
        },
        {
          title: '辅导老师',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '创建人',
          align: 'center',
          dataIndex: 'createBy',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/schoolCounselingConfig/list',
        delete: '/schoolCounselingConfig/delete',
        deleteBatch: '/schoolCounselingConfig/deleteBatch',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {},
}
</script>
<style scoped lang="less">
@import '~@assets/less/common.less';
.table-card {
  /deep/ .ant-card-body {
    padding: 0 !important;
  }
}
</style>
